import { Component, OnInit, Input, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { BdGraph } from 'src/lib/graph/graph.model';
import { ViewTreeNode } from 'src/app/engine/models/view.tree-node';
import { BdGraphService } from 'src/lib/graph/graph.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { Store } from '@ngxs/store';
import { takeUntil } from 'rxjs/operators';
import { CollapseNode, ExpandNode } from 'src/app/engine/state/nodes/engine.nodes.actions';
import { TreeTheme } from '../tree/tree.component';
import { GraphUtils } from 'src/lib/graph/graph-utils';

export interface NodeEvent {
  node: ViewTreeNode;
  checked: boolean;
}

@Component({
  selector: 'app-tree-group',
  templateUrl: './tree-group.component.html',
  styleUrls: ['./tree-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TreeGroupComponent implements OnInit, OnDestroy {
  treeTheme = TreeTheme;

  @Input()
  public get graph(): BdGraph<ViewTreeNode> {
    return this._graph;
  }
  public set graph(value: BdGraph<ViewTreeNode>) {
    if (!value) {
      return;
    }

    this._graph = value;
    this.graphSubject.next(value);
  }
  private _graph: BdGraph<ViewTreeNode>;
  private graphSubject = new BehaviorSubject<BdGraph<ViewTreeNode>>(null);

  @Input()
  theme: TreeTheme = TreeTheme.Dark;

  @Input()
  node: ViewTreeNode;

  nodes: ViewTreeNode[] = [];
  childCount: number;

  private ngUnsubscribe = new Subject();
  
  constructor(
    private graphService: BdGraphService,
    private store: Store
  ) { }

  ngOnInit() {
    this.graphSubject
      .pipe(
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe(graph => {
        if (!graph) {
          return;
        }
        this.getNodes();
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  getNodes() {
    const nodeIds = (this.node) ? 
      GraphUtils.getSuccessors(this.graph, this.node.id) : 
      GraphUtils.getRoots(this.graph);

    this.nodes = this.graphService.getNodes(this.graph, nodeIds);
  }

  countChildren(node: ViewTreeNode) {
    return GraphUtils.getSuccessors(this.graph, node.id).length;
  }

  hasChildren(node: ViewTreeNode) {    
    return this.countChildren(node) > 0;
  }

  trackTreeNode(node: ViewTreeNode) { 
    return node.id; 
  }

  handleExpandClick(node: ViewTreeNode, expanded: boolean) {
    (expanded) ?
      this.store.dispatch(new CollapseNode(node)) :
      this.store.dispatch(new ExpandNode(node));
  }
}
